import { render, staticRenderFns } from "./Caishou.vue?vue&type=template&id=2bf5d2f2&scoped=true&"
import script from "./Caishou.vue?vue&type=script&lang=js&"
export * from "./Caishou.vue?vue&type=script&lang=js&"
import style0 from "./Caishou.vue?vue&type=style&index=0&id=2bf5d2f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf5d2f2",
  null
  
)

export default component.exports